'use strict'

import ApiClient from './ApiClient'
import qs from 'qs'

export default class ExtriggerRepository {
  /**
   * きっかけ一覧取得
   * @param params
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/extriggers`, { params })
  }

  /**
   * きっかけ情報取得
   * @param id ID
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/extriggers/${id}`)
  }

  /**
   * きっかけ作成
   * @param data 登録値
   * @returns {*}
   */
  post (data) {
    return ApiClient().post(`/extriggers`, qs.stringify(data))
  }

  /**
   * きっかけ更新
   * @param id id
   * @param params 登録値
   * @returns {*}
   */
  put (id, params) {
    return ApiClient().put(`/extriggers/${id}`, qs.stringify(params))
  }

  /**
   * きっかけ削除
   * @param id id
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/extriggers/${id}`)
  }

  /**
   * 指定された複数IDのきっかけ情報を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/extriggers/delete`, data)
  }

  /**
   * 選択された複数IDの表示順を別の場所に移動します
   * @param {object} params
   * @returns {*}
   */
  sort (params) {
    return ApiClient().put(`/extriggers/sort`, params)
  }

  /**
   * 選択用きっかけ情報一覧を取得
   * @returns {*}
   */
  getChoices () {
    return ApiClient().get(`/extriggers/choices`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ExtriggerRepository.js